import React from 'react'
import styles from '../layout.module.scss'

const PageSidebar: React.FC<React.ReactNode> = ({ children }) => {
  return <aside className={styles.sidebar}>{children}</aside>
}

export default PageSidebar
